export const purchaseLimits: Record<string, number> = {
  EUR: 10000,
  USD: 11700,
  GBP: 8900,
  AUD: 17800,
  KRW: 16600000,
  JPY: 1785000,
};
